module.exports = __webpack_public_path__ + "static/media/YM63_1.0111f816.jpg";